import { BasketDetailsModel, BasketItemModel, BasketValidationResultModel, ProductTypes } from 'models/Basket';

export function validateBasketItems(basket: BasketDetailsModel): BasketValidationResultModel {
    if (!basket || !basket.deliveryAddress?.postcode) {
        return { isValid: true, invalidItems: [], sofaShields: [] };
    }

    const isRepublicOfIreland = Boolean(basket.deliveryAddress.postcode.isEirCode);
    const isNorthernIreland = Boolean(basket.deliveryAddress.postcode.isNorthernIrelandPostcode);
    const isIrelandDelivery = isRepublicOfIreland || isNorthernIreland;

    const invalidItems: BasketItemModel[] = [];
    const sofaShields: BasketItemModel[] = [];

    const sortedAscEntries = basket.entries.sort((a, b) => b.entryNumber - a.entryNumber);

    if (isIrelandDelivery) {
        const nonCompliantItems = sortedAscEntries.filter(e => (e.product.type === ProductTypes.DefaultProduct) && !e.product.eudrCompliant) || [];
        invalidItems.push(...nonCompliantItems);
    }

    if (isRepublicOfIreland) {
        const sofashieldItems = sortedAscEntries.filter(e => e.sofashieldQuantity > 0) || [];
        sofaShields.push(...sofashieldItems);
    }

    return {
        isValid: invalidItems.length === 0 && sofaShields.length === 0,
        invalidItems,
        sofaShields
    };
}
